import { Component, OnInit } from '@angular/core';
import { ServiceStock } from '../service-stock.service';

import { zip, toRem, toVh, toVhR, toVhU, toVw, toVwR, toVwU, $fontWeightBold, $fontWeightExtraBold, $fontWeightLight, $fontWeightMedium, $fontWeightRegular, $fontWeightSemiBold } from "../utils/ux";

declare let $: any;

@Component({
  selector: 'app-push-notification-enable',
  templateUrl: './push-notification-enable.component.html',
  styleUrls: ['./push-notification-enable.component.scss']
})
export class PushNotificationEnableComponent implements OnInit {

  constructor(private services: ServiceStock) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

    setTimeout(function () {
      $('.notfileslider').slick('slickGoTo', 1);
      setTimeout(function () {
        $('.notfileslider').slick('slickGoTo', 2);
      }, 600);
    }, 3000);

    $('.notfileslider').slick({
      dots: true,
      infinite: false,
      speed: 500,
      arrows: false,
      swipe: true,
      customPaging: function (slider, i) {
        return '<span></span>';
      },
      fade: true,
      cssEase: 'linear'
    }).on('afterChange', function (event, slick, direction) {
      for (var i = 0; i < slick.$slides.length; i++) {
        var $slide = $(slick.$slides[i]);
        if ($slide.hasClass('slick-current')) {
          if ($slide.attr('data-slick-index') == 0) {
            $('.notifi-wave img').css({ 'margin-left': '-17rem' });
            $('.notifi-mobile').css({ 'bottom': '-47rem' });
            $('.notfi-screen').css({ 'border-radius': '0 0 0 20px' });
          }
          if ($slide.attr('data-slick-index') == 1) {
            $('.notifi-wave img').css({ 'margin-left': '-65rem' });
            $('.notifi-mobile').css({ 'bottom': '-15rem' });
            $('.notfi-screen').css({ 'border-radius': '0 0 0 0' });
          }
          if ($slide.attr('data-slick-index') == 2) {
            $('.notifi-wave img').css({ 'margin-left': '-95rem' });
            $('.notifi-mobile').css({ 'bottom': '-15rem' });
            $('.notfi-screen').css({ 'border-radius': '0 0 20px 0' });
          }
        }
      }
    });
    $('.notfi-actions a').click(function () {
      //$('.welcome-notificaion').css({'transform': 'scale(0)' });
    });
  }

  doLater() {
    setTimeout(function () {
      //$('.notfi-screen').css({'border-radius': '20px 20px 20px 20px' });
      $('.notfi-screen').css({ 'border-radius': toVwU(20) });
    }, 100);
    $('.notfi-text').fadeOut(200);
    $('.welcome-notificaion').css('background', 'none');
    $('.notfi-screen *').fadeOut(400);

    $('.notfi-screen').animate({
      // borderRadius: '20px',
      //width: '144px',
      width: toVwU(144),
      //left: '47px', 
      left: toVwU(44),
      //top: '15.8rem',
      top: toVhU(288),
      //height: '169px',
      height: toVhU(169),

      opacity: 0.5
    }, 600, function () {
      //$('.notfi-screen').fadeOut(100);
      $('.notfi-screen').fadeOut(300, () => {
        //localStorage.setItem('PushNotification', '0');
        localStorage.setItem('dontPromptPushPermission', '1');
      });
    });
    //localStorage.setItem('PushNotification','0');

    // var _this = this;
    // 
    // setTimeout(function(){
    //   _this.services.router.navigate(['/welcome/appnavigator']);
    // }, 1500);    
  }

  doConfirm() {
    if(!this.services.fcmService){
      return;
    }
    this.services.fcmService.requestPushNotificationPermission().then(
      (res)=>{
        setTimeout(function () {
          //$('.notfi-screen').css({'border-radius': '20px 20px 20px 20px' });
          $('.notfi-screen').css({ 'border-radius': toVwU(20) });
        }, 100);
        //localStorage.setItem('PushNotification','1');
        $('.notfi-text').fadeOut(200);
        $('.welcome-notificaion').css('background', 'none');
        $('.notfi-screen *').fadeOut(400);
    
        $('.notfi-screen').animate({
          // borderRadius: '20px',
          //width: '144px',
          width: toVwU(144),
          //left: '47px', 
          left: toVwU(44),
          //top: '15.8rem',
          top: toVhU(288),
          //height: '169px',
          height: toVhU(169),
    
          opacity: 0.5
        }, 600, function () {
          //$('.notfi-screen').fadeOut(100);
          $('.notfi-screen').fadeOut(300, () => {
            //localStorage.setItem('PushNotification', '1');
            localStorage.setItem('dontPromptPushPermission', '1');
          });
        });
        //localStorage.setItem('PushNotification','1');
        // var _this = this;
    
        // setTimeout(function(){
        //   _this.services.router.navigate(['/welcome/appnavigator']);
        // }, 1500);    
    });
        

  }

}
